import { QUESTION_DATA } from './questionnaire/questionData';
import { LocalStorageService } from './local-storage.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  constructor(private localStorageService: LocalStorageService) { }

  hasTestStarted(){
    const questionnaire = this.localStorageService.get('questionnaire');
    return Array.isArray(questionnaire);
  }

  hasTestFinished(){
    const questionnaire = this.localStorageService.get('questionnaire');
    return (Array.isArray(questionnaire) && questionnaire.length === QUESTION_DATA.length);
  }

  hasIntroFinished(){
    const hasIntroFinished = this.localStorageService.get('hasIntroFinished');
    if(hasIntroFinished !== null && hasIntroFinished === true){
      return true;
    }
    return false;
  }
}
